import {useStoreContext} from '@store/store-context';
import {hasStandardBillingAccess} from '@utils/billing-state';

export const useWorkspaceUseCase = () => {
  const {
    authStore: {auth},
  } = useStoreContext();
  const workspace = auth?.user?.workspace;
  const isBillingStandard = hasStandardBillingAccess(workspace?.billing);

  const isPerformanceActive = isBillingStandard;

  const isEngagementActive = isBillingStandard;

  const isCheckinsEnabled = workspace?.settings?.checkInStatus === 'enabled';

  const isActionItemEnabled =
    workspace?.settings?.actionItemStatus === 'enabled';

  const isGoalEnabled = workspace?.settings?.goalStatus === 'enabled';

  const isFeedBackEnabled = true;

  const isOneOnOneEnabled =
    workspace?.settings?.oneOnOne === 'enabled' &&
    process.env.REACT_APP_COMPANY_MEETING_FEATURE_ENABLED === 'enabled';

  return {
    isPerformanceActive,
    isEngagementActive,
    isCheckinsEnabled,
    isBillingStandard,
    isActionItemEnabled,
    isFeedBackEnabled,
    isOneOnOneEnabled,
    isGoalEnabled,
  };
};
